// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jn-1";
export var rowFirst = "_jn-3";
export var rowLast = "_jn-5";
export var rowMiddle = "_jn-4";
export var ticketListScroll = "_jn-2";
export var ticketStack = "_jn-0";